import { Root, Image, ImageWrapper } from './illustration.styles';
export interface IllustrationProps {
    src: string;
    mixBlendMode?: string;
    fitToContainer?: boolean;
    centerInContainer?: boolean;
    /**
     * Text for screen readers. Empty by default, which marks the image as decorative: most
     * illustrations sit next to text that says the same (a logo beside its name). Give it text
     * when the image carries meaning of its own.
     */
    alt?: string;
}
export function Illustration({
    src,
    mixBlendMode = 'initial',
    fitToContainer = false,
    centerInContainer = true,
    alt = '',
}: IllustrationProps) {
    return (
        <Root $centerInContainer={centerInContainer}>
            <ImageWrapper
                src={src}
                $mixBlendMode={mixBlendMode}
                $fitToContainer={fitToContainer}
                $centerInContainer={centerInContainer}
            >
                <Image src={src} alt={alt} />
            </ImageWrapper>
        </Root>
    );
}
